module.exports = __webpack_public_path__ + "static/images/gift2.0fa5949.png";